import React from 'react';
import PropTypes from 'prop-types';
import { CalenderIcon } from '../../icons/icons';
import DatepickerBox from '../../datepicker-box/datepicker-box';
import TextBox from '../../text-box/text-box';
import { getUserTimeZoneDateFormat } from '../../../helpers/dateHelper';

function VendorQuotationSection({
  quotationLabel,
  dateForm,
  setDateForm,
  bookingData,
  // showDatePicker,
  showDate,
  isContracted,
  showTimeInput,
  dateFormat,
  placeholder,
}) {
  return (
    <div className="form-row">
      <div className="icon">
        <CalenderIcon color="#395C85" size="1.667vw" />
      </div>
      <div className="form">
        <label className="label">
          {quotationLabel}
          <span className="required">*</span>
        </label>
        {!showDate ? (
          <DatepickerBox
            required={!isContracted}
            selectedDate={dateForm}
            setDate={(e) => setDateForm(e)}
            showTimeInput={showTimeInput}
            dateFormat={dateFormat}
            placeholder={placeholder}
          />
        ) : (
          <TextBox
            value={
              isContracted
                ? getUserTimeZoneDateFormat(bookingData?.scheduledPickupDate)
                : getUserTimeZoneDateFormat(bookingData?.quotationExpiryDate)
            }
            disabled
          />
        )}
      </div>
    </div>
  );
}

export default VendorQuotationSection;

VendorQuotationSection.propTypes = {
  quotationLabel: PropTypes.string.isRequired,
  bookingData: PropTypes.instanceOf(Object).isRequired,
  dateForm: PropTypes.instanceOf(Date).isRequired,
  setDateForm: PropTypes.func.isRequired,
  // showDatePicker: PropTypes.bool.isRequired,
  showDate: PropTypes.bool.isRequired,
  isContracted: PropTypes.bool,
  showTimeInput: PropTypes.bool,
  dateFormat: PropTypes.string,
  placeholder: PropTypes.string,
};

VendorQuotationSection.defaultProps = {
  isContracted: false,
  showTimeInput: false,
  dateFormat: 'dd/MM/yyyy',
  placeholder: PropTypes.string,
};
